// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { Dict, List } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    publicGet20PublicOrderBookSymbol (params?: {}): Promise<Dict | List>;
    publicGet10PublicTickers (params?: {}): Promise<Dict | List>;
    publicGet10PublicCandlesSymbol (params?: {}): Promise<Dict | List>;
    publicGet10PublicTradesAll (params?: {}): Promise<Dict | List>;
    publicGet10PublicConfigurationCurrencies (params?: {}): Promise<Dict | List>;
    publicGet10PublicConfigurationPairs (params?: {}): Promise<Dict | List>;
    privateGet10Balances (params?: {}): Promise<Dict | List>;
    privateGet10OrdersActive (params?: {}): Promise<Dict | List>;
    privateGet10OrdersHistorical (params?: {}): Promise<Dict | List>;
    privateGet10OrdersVenueOrderId (params?: {}): Promise<Dict | List>;
    privateGet10OrdersFillsVenueOrderId (params?: {}): Promise<Dict | List>;
    privateGet10TradesPrivateSymbol (params?: {}): Promise<Dict | List>;
    privateGet10Transactions (params?: {}): Promise<Dict | List>;
    privatePost10Orders (params?: {}): Promise<Dict | List>;
    privatePut10OrdersVenueOrderId (params?: {}): Promise<Dict | List>;
    privateDelete10Orders (params?: {}): Promise<Dict | List>;
    privateDelete10OrdersVenueOrderId (params?: {}): Promise<Dict | List>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
